import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import selectAppState from 'app/store/selector';
import { Col } from '@guestyci/foundation/esm/Layout';
import theme from '@guestyci/foundation/theme/defaultTheme';
import TextField from '@guestyci/foundation/TextField';
import useTranslations from '@guestyci/localize/esm/useTranslations/useTranslations';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import _extends from '@babel/runtime/helpers/esm/extends';
import Button from '@guestyci/foundation/Button';

import config from 'config';
import AppStyle from '../Styles';
import Translations from '../Translations';
import MarketingLoginButton from '../components/MarketingLoginButton';

const useStyles = createStyles(() =>
  _extends(AppStyle, {
    root: {
      maxWidth: theme.breakpoints.values.sm,
      margin: '0 auto',
    },
    subhead: {
      fontSize: '1.25rem',
      textAlign: 'center',
      lineHeight: 1.3,
      maxWidth: 500,
    },
  }));

const ExistingEmailContentPage = () => {
  const classes = useStyles();
  const state = useSelector(selectAppState);

  const loginPageURL = config.applicationHost.concat(`/?email=${state.email}`);
  const forgotPassPageURL = config.applicationHost.concat(
    `/forgot-password?email=${state.email}`
  );

  const [buttonLabel] = useTranslations(Translations.step3.buttons);
  const [heading, subheading] = useTranslations(Translations.existingEmail.titles);
  const [resetPasswordButtonLabel] = useTranslations(Translations.existingEmail.buttons);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goToForgotPass = () => {
    window.location = forgotPassPageURL;
  };

  return (
    <Col className={classes.root} spacing={10} id="existing-email-page-container">
      <Col spacing={3} id="existing-email-heading">
        <TextField className={classes.pageHeading} align="center">
          {heading}
        </TextField>
        <TextField className={classes.subhead}>{subheading}</TextField>
      </Col>
      <Col spacing={3} align="center" id="existing-email-buttons-container">
        <MarketingLoginButton successLink={loginPageURL}>{buttonLabel}</MarketingLoginButton>
        <Button
          id="existing-email-reset-password-button"
          className={classes.marketingSuccessButtonClear}
          onClick={goToForgotPass}
        >
          {resetPasswordButtonLabel}
        </Button>
      </Col>
    </Col>
  );
};

export default ExistingEmailContentPage;
